import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M18 22H6L12 16L18 22ZM7 19H3C1.89543 19 1 18.1046 1 17V5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V17C23 18.1046 22.1046 19 21 19H17V17H21V5H3V17H7V19Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "Airplay"
);
